/** Sign-in, registration, MFA challenge, password reset, Telegram sign-in. */
export default {
  email: "E-mail",
  password: "Password",
  passwordHint: "At least 8 characters.",
  displayName: "Name",
  optional: "optional",
  showPassword: "Show password",
  hidePassword: "Hide password",
  or: "or",
  submit: {
    login: "Sign in",
    register: "Create account",
    verify: "Confirm",
    send: "Send link",
    reset: "Set new password",
  },
  login: {
    title: "Sign in",
    noAccount: "New here?",
    toRegister: "Create an account",
    forgot: "Forgot password?",
  },
  register: {
    title: "Create your account",
    subtitle: "A free account in a minute: an e-mail and a password, or Telegram in one tap.",
    haveAccount: "Already registered?",
  },
  fieldErrors: {
    email: "Enter an e-mail like name@example.com",
    password: "At least 8 characters",
  },
  telegram: {
    button: "Continue with Telegram",
    notConfigured: "Telegram sign-in is not available yet",
    opening: "Opening Telegram…",
    waitingTitle: "Confirm in Telegram",
    waitingHint: "In @{bot}, tap “Confirm sign-in”. This page signs you in by itself.",
    waitingHintStepUp: "In @{bot}, tap “Confirm”. This window continues by itself.",
    stepOpen: "Open the bot",
    stepConfirm: "Tap Confirm",
    stepBack: "Come back here",
    openAgain: "Open Telegram again",
    openWeb: "Open in the browser",
    qr: "No Telegram on this computer? Scan with your phone’s camera.",
    cancel: "Cancel",
    expired: "The request has expired. Start again — it takes a second.",
    unavailable: "Could not start Telegram sign-in. Check the connection and try again",
  },
  mfa: {
    title: "Two-step verification",
    totpLabel: "Code from your authenticator app",
    useKey: "Use a security key or passkey",
    useRecovery: "Use a recovery code",
    useTotp: "Use the authenticator app",
    recoveryLabel: "Recovery code",
    keyWaiting: "Follow the prompt of your browser…",
  },
  forgot: {
    title: "Reset password",
    subtitle: "We will e-mail you a link to set a new password.",
    sent: "If an account exists for this e-mail, the link is on its way. Check your inbox.",
  },
  reset: {
    title: "Set a new password",
    done: "Password changed. All your sessions were signed out — sign in again.",
  },
  verify: {
    optional: "Not confirmed yet — optional.",
    sendLink: "Send a link",
    title: "E-mail confirmation",
    working: "Confirming…",
    done: "Your e-mail is confirmed.",
    banner: "Confirm your e-mail: we sent a link to {email}.",
    resend: "Send again",
    resent: "Sent.",
  },
  toLogin: "Back to sign in",
  passwordProblems: {
    too_short: "Too short: at least 8 characters",
    too_long: "Too long",
    contains_email: "Must not contain your e-mail name",
    too_simple: "Too simple: use more different characters",
  },
} as const;
